<template>
  <div class="main">
    <Header 
      :show="true"
      title="卸料罐口"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        text="请注意罐口周围人员与财产安全，谨慎操作"
      />
      <van-form>
        <van-field
          clickable
          name="picker"
          :value="listQuery.port"
          label="罐口"
          placeholder="点击选择罐口"
          required
          @click="port.show = true"
        />
        <van-popup v-model="port.show" position="bottom">
          <van-picker
            show-toolbar
            :columns="port.columns"
            @confirm="handleMaterialPortSelect"
            @cancel="port.show = false"
          />
        </van-popup>
        <van-field
          ref="detail"
          v-model="listQuery.reason"
          rows="1"
          autosize
          label="开启原因"
          type="textarea"
          maxlength="100"
          placeholder="请输入开启罐口的原因"
          show-word-limit
          required
        />
        <div style="margin: 16px;" v-if="checkPermission([62])">
          <van-button round block type="info" @click="handleOperateConfirmDialog">
            确定
          </van-button>
        </div>
      </van-form>
      <div style="height: 2rem;" />
      
      <van-overlay :show="loading" @click="loading = false">
        <div class="wrapper" @click.stop>
          <van-loading type="spinner" color="#1989fa" />
        </div>
      </van-overlay>
      
      <van-dialog 
        v-model="dialogVisibleOperate" 
        title="确认开启？"
        show-cancel-button
        :before-close="handleBeforeCloseDialog"
      >
        <div style="display: flex; justify-content: center; align-items: center; font-size: 2vh; margin: 20px 0;">
          开启罐口：{{ listQuery.port }}
        </div>
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>

  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getConfigList, openOne } from '@/api/port.js'

  export default {
    name: "ServiceControlPort",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        loading: false,
        dialogVisibleOperate: false,
        listQuery: {
          serial: null,
          port: '',
          reason: ''
        },
        port: {
          show: false,
          columns: [],
          options: []
        },
        lastTime: (new Date()).getTime()
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleGetPortList()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/system/staff/create', 
          query: {} ,
        })
      },
      portNameToId(value) {
        const len = this.port.options.length
        for (let i=0; i<len; i++) {
          if (this.port.options[i].name === value) {
            return this.port.options[i].id
          }
        }
        return null
      },
      handleGetPortList() {
        const data = {}
        getConfigList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data
            this.port.columns = []
            for (let i=0; i<items.length; i++) {
              this.port.columns.push(items[i].portName)
              this.port.options.push({
                id: items[i].id,
                name: items[i].portName
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleMaterialPortSelect(value) {
        this.listQuery.port = value
        this.port.show = false
      },
      onSelectReasonChoose(item) {
        this.listQuery.reason.show = false
        this.listQuery.reason.name = item.name
      },
      handleOperateConfirmDialog() {
        if ((this.listQuery.port === null)) {
          showPhoneAlarm(true, 'toast', null, 2000, 300, '罐口开启', '请选择罐口号')
        } else if ((this.listQuery.reason === '')) {
          showPhoneAlarm(true, 'toast', null, 2000, 300, '罐口开启', '请输入开启原因')
        } else {
          this.dialogVisibleOperate = true
        }
      },
      handleBeforeCloseDialog(action, done) {
        if (action === 'confirm') {
          const nowTime = (new Date()).getTime()
          if (nowTime - this.lastTime < 60) {
            showPhoneAlarm(true, 'toast', null, 2000, 300, '罐口开启', '请等待罐口开启完成')
            return
          }
          this.lastTime = (new Date()).getTime()
          const data = {
            port: this.portNameToId(this.listQuery.port),
            reason: this.listQuery.reason
          }
          this.loading = false
          openOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '罐口开启', data.message)) {
              done(true)
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        } else {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '取消开启')
          done(true)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改

  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
